import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LowPriority from '@material-ui/icons/LowPriority';
import ChangeStatusShopDialog from '../molecules/ChangeStatusShopDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false)
);

const button = enhance(
  ({
    classes,
    openChange,
    disabled,
    updateOpenChange,
    params,
    onClickAction,
    statusShop,
    setStatusShop,
    message,
    setMessage,
    openChangeConfirm,
    updateOpenChangeConfirm,
    titleStatus
  }) => {
    const cancelAction = () => updateOpenChange(false);
    const changeAction = paramChange => {
      const param = {
        shopId: paramChange.shopId,
        status: statusShop
      };
      updateOpenChange(false);
      updateOpenChangeConfirm(false);
      onClickAction(param);
    };
    const updateChange = () => {
      updateOpenChange(true);
      setStatusShop(params.status);
    };
    let disableStatus = false;
    if (params.status === 'CLOSED') {
      disableStatus = true;
    }
    return (
      <div>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => updateChange(true)}
        >
          <LowPriority className={classes.leftIcon} />
          {titleStatus}
        </Button>
        <ChangeStatusShopDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          cancelAction={cancelAction}
          changeAction={() => changeAction(params)}
          target="Change"
          statusShop={statusShop}
          setStatusShop={setStatusShop}
          disableStatus={disableStatus}
          message={message}
          setMessage={setMessage}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          canOpen={
            params.status === 'PRE_AVAILABLE' || params.status === 'AVAILABLE'
          }
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
